var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Dropdown } from '../ts/tools/Dropdown';
export class ProductPreview extends Component {
    constructor() {
        super('ProductPreview', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.preview-product').each((item) => {
                const dropdowns = [];
                let pills = item.find('.pill');
                let timeout;
                item.find('.dropdown').forEach((dropdown) => {
                    dropdowns.push(new Dropdown(dropdown));
                });
                item.on('mouseenter', (event) => {
                    if ($(window).width() < 768)
                        return;
                    ProductPreview.setDropdownFeaturesPosition();
                    dropdowns.forEach((dropdown) => {
                        dropdown.slideDown();
                    });
                    clearTimeout(timeout);
                    pills.addClass('d-none');
                }).on('mouseleave', (event) => {
                    if ($(window).width() < 768)
                        return;
                    dropdowns.forEach((dropdown) => {
                        dropdown.slideUp();
                    });
                    timeout = window.setTimeout(() => {
                        pills.removeClass('d-none');
                    }, 250);
                });
            });
            this.success();
        });
    }
    static setDropdownFeaturesPosition() {
        $('.dropdown-features').forEach((item) => {
            const parent = ($(item).parents('.preview-default').length > 0) ? $(item).parents('.preview-default') : $(item).parents('.font-editor');
            const margin = $('body').hasClass('single-product') ? 18 : 9;
            console.log(parent.find('.title-features').get(0).getBoundingClientRect().left);
            $(item).get(0).style.left = (parent.find('.title-features').get(0).getBoundingClientRect().left - margin) + 'px';
        });
    }
}
